import { ATTRIBUTION_TAB_IDS, REQUEST_TYPES, TRANSLATE_PREFIX } from './consts';
import { isDraftBlockingErrorKey } from './validators';

const POSTBACK_TAB_IDS = new Set([ATTRIBUTION_TAB_IDS.POSTBACK_OVERALL_SETUP, ATTRIBUTION_TAB_IDS.POSTBACK_TEMPLATES]);

// Each validated field → tab it lives on. Add a new line here to enable reasons for a new field.
const FIELD_TO_TAB = {
    postback_url_base: ATTRIBUTION_TAB_IDS.POSTBACK_OVERALL_SETUP,
    conversions_postback_url: ATTRIBUTION_TAB_IDS.POSTBACK_OVERALL_SETUP,
    post_install_events_postback_url: ATTRIBUTION_TAB_IDS.POSTBACK_OVERALL_SETUP,
    revenue_events_postback_url: ATTRIBUTION_TAB_IDS.POSTBACK_OVERALL_SETUP,
    fraud_postbacks_postback_url: ATTRIBUTION_TAB_IDS.POSTBACK_OVERALL_SETUP,
};

const getInvalidFieldReasons = (fieldValidity, formData, isTabVisible) =>
    Object.entries(FIELD_TO_TAB)
        .filter(([, tabId]) => isTabVisible(formData, { id: tabId }))
        .filter(([field]) => fieldValidity[field] === false)
        .map(([field, tabId]) => ({
            tabId,
            field,
            reasonKey: `${TRANSLATE_PREFIX}.ERRORS.${field.toUpperCase()}_INVALID`,
        }));

const ATTRIBUTION_RULES = {
    // Structural / format issues that block draft are detected by the Formik validators
    // (see ``validators.js``); we filter their error keys via ``isDraftBlockingErrorKey``.
    // Async URL validity lives outside Formik in ``fieldValidity`` and is folded in here.
    isDraftBlocked: (formData, { fieldValidity = {}, errors = {} } = {}) => {
        if (Object.keys(errors).some(isDraftBlockingErrorKey)) return true;
        return getInvalidFieldReasons(fieldValidity, formData, ATTRIBUTION_RULES.isTabVisible).length > 0;
    },

    // Returns only reasons not already in the Formik ``errors`` map (currently just URL validity);
    // FormActionWarnings combines this with the draft-blocking subset of Formik errors for display.
    getDraftBlockedReasons: (formData, { fieldValidity = {} } = {}) =>
        getInvalidFieldReasons(fieldValidity, formData, ATTRIBUTION_RULES.isTabVisible),

    isTabVisible: (formData, tab) => {
        if (!POSTBACK_TAB_IDS.has(tab.id)) return true;
        const general = formData[ATTRIBUTION_TAB_IDS.GENERAL] || {};
        return general.receive_postbacks ?? true;
    },

    isTabDisabled: (formData, _tab, index) => {
        const general = formData[ATTRIBUTION_TAB_IDS.GENERAL] || {};
        return !general.platform_template && index > 0;
    },

    tabDisabledTooltipKey: `${TRANSLATE_PREFIX}.TOOLTIPS.TAB_DISABLED`,
};

const DEFAULT_RULES = {
    isDraftBlocked: () => false,
    getDraftBlockedReasons: () => [],
    isTabVisible: () => true,
    isTabDisabled: () => false,
    tabDisabledTooltipKey: undefined,
};

const FORM_TYPE_RULES = {
    [REQUEST_TYPES.ATTRIBUTION]: ATTRIBUTION_RULES,
};

export const getFormTypeRules = type => ({ ...DEFAULT_RULES, ...FORM_TYPE_RULES[type] });
